import React from 'react';
import { CopyText } from '../../../../UiKit';
import { Eye, Mail } from 'lucide-react';

export const UserEmailV1 = ({ emailInfo = null, onClick = () => {} }) => {
  return (
    <div className='tw-flex tw-items-center tw-gap-3'>
      <Mail size={16} className='tw-text-grey-600' strokeWidth={1.8} />
      {emailInfo ? (
        <div
          className='tw-text-zinc-600 tw-font-regular tw-leading-tight'
          data-dd-privacy='mask'
        >
          <CopyText type='email' title={emailInfo.email} masking={false} />
        </div>
      ) : (
        <div className='tw-flex tw-items-center tw-text-grey-800'>
          <span className='tw-leading-none tw-mb-[2px] tw-min-w-[11rem] tw-whitespace-nowrap tw-text-left tw-text-zinc-600 tw-font-regular'>
            ••••••@••••com
          </span>
          <Eye
            size={16}
            strokeWidth={1.5}
            className='tw-cursor-pointer tw-text-grey-400 hover:tw-text-grey-500 tw-transition-colors tw-ease-in-out tw-duration-200'
            onClick={onClick}
            data-dd-action-name='Unmask Customer Email'
          />
        </div>
      )}
    </div>
  );
};
